<template>
  <main class="code d-flex align-items-center" v-cloak>
    <div class="w-100">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <input
                name="code"
                type="text"
                class="form-control text-left"
                :placeholder="$t('Inserisci codice...')"
                v-model="code"
                id="code"
              />
              <label for="code" class="h5">{{$t('Inserisci il tuo codice')}}</label>
            </div>
            <div class="text-right">
              <button @click="redeemCode" type="button" class="btn btn-primary">{{$t('Invia')}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "insert-code",
  data() {
    return {
      code: ""
    }
  },
  methods: {
    async redeemCode() {
      this.$store.commit("showSpinner");
      try {
        let response = await this.$http.post(
          "api/v1/campaigns/" + this.$store.state.campaign.id + "/codes/redeem/code",
          {
            code: this.code
          }
        );

        this.$store.commit("pushMessage", {
          type: "congratulation",
          title: this.$t("Congratulation"),
          text:
            this.$t("With this code you have earned"),
          points: 
            this.$t("points") +
            ":" +
            _.get(response, "data.data.points") +
            "<br>" + this.$t("coins") + ":" +
            _.get(response, "data.data.coins")
        });
        this.$store.dispatch('getUserInfo');
      } catch (e) {
        let errorResponse = _.get(e, 'response', 0);
        switch (errorResponse.status) {
          case 422:
            this.$store.commit("pushMessage", {
              type: "waiting",
              title: "Invalid data",
              text: "Please retry"
            });
            break;
          case 404:
            case 422:
            this.$store.commit("pushMessage", {
              type: "waiting",
              title: "Invalid code",
              text: "Please retry"
            });
            break;
          case 409:
            this.$store.commit("pushMessage", {
              type: "waiting",
              title: "Already used",
              text: this.$t("You have already used this code")
            });
            break;
          case 425:
            this.$store.commit("pushMessage", {
              type: "waiting",
              title: "Maximum usage reached",
              text: this.$t("You exceeded the maximum usage for this code")
            });
            break;
          default:
            this.$store.commit("pushMessage", {
              type: "waiting",
              title: "Something went wrong",
              text: "Please retry"
            });
        }
      }

      this.$store.commit("hideSpinner");
    }
  }
};
</script>

<style>
</style>
